import { render, staticRenderFns } from "./cropperImg.vue?vue&type=template&id=04703c65&scoped=true"
import script from "./cropperImg.vue?vue&type=script&lang=js"
export * from "./cropperImg.vue?vue&type=script&lang=js"
import style0 from "./cropperImg.vue?vue&type=style&index=0&id=04703c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04703c65",
  null
  
)

export default component.exports